/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Tabcolor1Inputs */

const en_entity_tabcolor1 = /** @type {(inputs: Entity_Tabcolor1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tab Color`)
};

const de_entity_tabcolor1 = /** @type {(inputs: Entity_Tabcolor1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tab-Farbe`)
};

/**
* | output |
* | --- |
* | "Tab Color" |
*
* @param {Entity_Tabcolor1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_tabcolor1 = /** @type {((inputs?: Entity_Tabcolor1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Tabcolor1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_tabcolor1(inputs)
	return de_entity_tabcolor1(inputs)
});
export { entity_tabcolor1 as "entity_tabColor" }